import TMenu from './menu.vue'
import TMenuGroup from './menu-group.vue'
import TSubmenu from './submenu.vue'
import TMenuItem from './menu-item.vue'

TMenu.install = Vue => {
  Vue.component(TMenu.name, TMenu)
}
TMenuGroup.install = Vue => {
  Vue.component(TMenuGroup.name, TMenuGroup)
}
TSubmenu.install = Vue => {
  Vue.component(TSubmenu.name, TSubmenu)
}
TMenuItem.install = Vue => {
  Vue.component(TMenuItem.name, TMenuItem)
}

export {
  TMenu,
  TMenuGroup,
  TSubmenu,
  TMenuItem
}



// WEBPACK FOOTER //
// ./src/module/menu/index.js